import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useLanguage } from '../../../contexts/LanguageContext';

const CTASection = ({ onRequestAccess }) => {
  const { t } = useLanguage();

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-gradient-to-br from-[#0025cc] to-[#0025cc] text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative max-w-4xl mx-auto px-4 md:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6 md:mb-8">
          <Icon name="Sparkles" size={20} color="#FFFFFF" />
          <span className="text-sm md:text-base font-medium">{t('cta.badge')}</span>
        </div>
        
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 md:mb-6">
          {t('cta.title')}
        </h2>
        
        <p className="text-base md:text-lg text-white/90 mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed">
          {t('cta.subtitle')}
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8 md:mb-12">
          <Button 
            variant="default" 
            size="lg"
            onClick={onRequestAccess}
            className="bg-white text-[#0025cc] hover:bg-white/90 w-full sm:w-auto"
            iconName="ArrowRight"
            iconPosition="right"
          >
            {t('cta.requestAccessNow')}
          </Button>
        </div>
        
        <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-sm md:text-base">
          <div className="flex items-center gap-2">
            <Icon name="Check" size={20} color="#FFFFFF" />
            <span>{t('cta.noCreditCard')}</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Check" size={20} color="#FFFFFF" />
            <span>{t('cta.manualApproval')}</span>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="Check" size={20} color="#FFFFFF" />
            <span>{t('cta.anonymous')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;